import React from 'react';
import { MenuButton } from './menu-button';
import { MenuItems } from './menu-items';
import { useMenu } from './useMenu';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    button,
    items,
    tooltip,
    label,
    anchor: _anchor,
    onOpen: _onOpen,
    onClose: _onClose,
    onHoverStart: _onHoverStart,
    onHoverStop: _onHoverStop,
}) => {
    const emptyFn = () => {};
    const { anchor, onClose, onBtnClick, onItemClick, onBtnKeyDown } = useMenu({
        items,
        _onOpen: _onOpen ?? emptyFn,
        _onClose: _onClose ?? emptyFn,
        _onHoverStart: _onHoverStart ?? emptyFn,
        _onHoverStop: _onHoverStop ?? emptyFn,
    });
    return (
        <>
            <MenuButton
                button={button}
                label={label}
                tooltip={tooltip}
                onClick={onBtnClick}
                onHoverStart={_onHoverStart}
                onHoverStop={_onHoverStart}
            />
            <MenuItems
                items={items}
                anchor={anchor}
                onClose={onClose}
                onItemClick={onItemClick}
                onBtnKeyDown={onBtnKeyDown}
                onHoverStart={_onHoverStart}
                onHoverStop={_onHoverStop}
            />
        </>
    );
};

export const Menu = React.memo(Component);
